<template>
  <el-form
      @submit.prevent="triggerFormSubmit"
      ref="refFormCanvas"
      :model="model"
      class="common-form">

      <div class="flex justify-between player-setup-canvas">
        <div class="w-[182px]">
          <h2 class="text-[13px] font-semibold text-[#23569F] uppercase leading-[1.5]">*{{ $t("playerSetup.canvasName") }}</h2>
          <div v-show="!showInput && !error" class="flex items-center h-[40px]">
            <div class="inline-block text-[12px] p-[6px] pl-[16px] rounded-[3px] leading-[12px] box-border cursor-pointer border-none normal-case bg-light-gray">
              <div class=" flex">
                <span class="inline-block flex-auto mr-3">{{ model.name }}</span>
                <a @click="handleEditIconOnClick" v-if="editable" class="edit-icon w-[12px] h-[12px] bg-no-repeat bg-cover bg-center inline-block flex-none"><span class="hidden">Edit</span></a>
              </div>
            </div>
          </div>

          <el-form-item prop="name" :error="formError" class="canvas-name">
            <el-input v-show="showInput || error"
              v-model="model.name"
              ref="canvasNameInput"
              @blur="handleInputOnChange"
              @change="handleInputOnChange"
              ></el-input>
          </el-form-item>
        </div>
        <div class="w-[182px]">
          <h2 class="text-[13px] font-semibold text-[#23569F] uppercase leading-[1.5]">{{ $t("playerSetup.canvasSize") }}</h2>
          <p v-show="canvasSize != null" class="h-[40px] flex items-center text-xs color-[#121212] canvas-size">{{$t('playerSetup.canvasSizeFormatted', { canvasSize })}}</p>
        </div>
      </div>
      <div class="mt-3">
        <p v-if="error" class="text-[#F46D6D]">
          <font-awesome-icon icon="fa-solid fa-circle-exclamation" />
          {{ error }}
        </p>
        <p class="text-xs text-[#696B71]">
          {{ $t("playerSetup.canvasVideoNote", { canvasType: $t(`playerSetup.canvasVideoNoteType_${canvasType}`) }) }}
        </p>
      </div>
  </el-form>
</template>

<script src="./player-setup-canvas.js"></script>
<style lang="scss" src="./player-setup-canvas.scss"></style>
